import styled from "styled-components";
import {Radio, Checkbox, Input} from "antd";

export const Select = styled.select`
    padding: 5px 35px 5px 5px;
    font-size: 14px;
    border: 1px solid #ccc;
    height: 40px;
    background: 96% / 15% no-repeat #eee;
`;

export const RadioContainer = styled.div`
    margin: auto;
`;

export const RadioList = styled(Radio)`
    display: block;
    height: 30px;
    line-height: 30px;
`;
export const BottomCheckbox = styled(Checkbox)`
    margin-top: 20px;
    margin-left: 15px;
    margin-right: 10px;
`;

export const Text = styled.span`
    color: ${props => (props.cancel ? "#00000040" : "black")};
`;
export const CancelInput = styled(Input)`
    margin-top: 10px;
    ::placeholder {
        color: #40a9ff;
    }
`;
